import type { ComponentType } from "react";

import ErrorScreen, { type ErrorScreenProps } from "../error/ErrorScreen";
import LoadingScreen from "../loading/LoadingScreen";

export const AwaitConfig: {
    loading: ComponentType;
    error: ComponentType<ErrorScreenProps>;
} = {
    loading: LoadingScreen,
    error: ErrorScreen,
};
